export default __webpack_public_path__ + "static/media/img_maintenance_v1.b8ed9617.png";